import { Modal } from '@/components/widgets/modal';
import { useEffect, useState } from 'react';
import { Button } from '@nf/ui';
import { Icon } from '@/components/icons/svg-icons';
import { voucherPromoModalStyle } from './voucher-promo-modal.style';
import { useTranslations } from 'next-intl';
import { useLocalStorage } from '@nf/utils-common/hooks';
import clsx from 'clsx';
import { useAppearanceStore } from '@/store/appearance';
import { ViewEnum } from '@/types';
import { useGetSiteConfigs } from '@/hooks/query/use-site-configs';
import { AutoPopupModal } from '@/components/widgets/modal';
import { AutoPopupKey } from '@nf/auto-popup-handler';

export const VoucherPromoModal = () => {
	const t = useTranslations('General');
	const [isVoucherPromoTriggered, setIsVoucherPromoTriggered] = useLocalStorage('persist:is-voucher-promo-triggered', false);
	const [isOpen, setIsOpen] = useState(false);
	const view = useAppearanceStore(state => state.view);
	const { SiteConfigsData } = useGetSiteConfigs();
	const isHeadlessStyle = view === ViewEnum.galaxy && SiteConfigsData?.EnableHeadlessForGalaxy 

	useEffect(() => {
		const voucherPromoTrigger = (() => setIsOpen(true)) as EventListener
		if (!isVoucherPromoTriggered) {
			document.addEventListener('trigger-voucher-promo-modal', voucherPromoTrigger);
		}
		return () => {
			document.removeEventListener('trigger-voucher-promo-modal', voucherPromoTrigger);
		}
	}, []);
	const closeModal = () => {
		setIsVoucherPromoTriggered(true);
		setIsOpen(false);
	}

	
	return (
		<AutoPopupModal
			popupKey={AutoPopupKey.VoucherPromoModal}
			isOpen={isOpen}
			closeModal={closeModal}
			variant="event"
			className={voucherPromoModalStyle.voucherPromoModal}
			showHeader={false}
		>
			<div 
				className={voucherPromoModalStyle.background}
			>
				<div 
					className={clsx(
						voucherPromoModalStyle.container, 
						{ [voucherPromoModalStyle.headlessContainer]: isHeadlessStyle }
					)}
				>
					<div className={voucherPromoModalStyle.voucherIconBg}>
						<div className={voucherPromoModalStyle.voucherIcon}>
							<Icon name="voucher" />							
						</div>
					</div>
					<div className={voucherPromoModalStyle.arrowImg}>
						<img 
							src="/events/reward/voucher-promo-arrow.png"
							alt="voucher-promo"
						/>
					</div>
					<div className={voucherPromoModalStyle.content}>
						<div className={voucherPromoModalStyle.text}>
							{t('lbl_obp06')}
						</div>
						<div className={voucherPromoModalStyle.text}>
							{t('lbl_obp07')}
						</div>
					
						<Button
							className={voucherPromoModalStyle.button}
							shape="capsule"
							onClick={closeModal}
						>
							{t('lbl_GotIt')}
						</Button>
					</div>
				</div>
			</div>
		</AutoPopupModal>
	)
}

